import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-cm-permissions',
  templateUrl: './cm-permissions.component.html',
  styleUrls: ['./cm-permissions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CmPermissionsComponent {

}
